<template>
  <spr-dialog name="engineer" :show="show" :title="title" @confirm="handleConfirm" @open="handleOpen" @update:show="(flag) => this.$emit('update:show', flag)">
    <el-form ref="form" :model="Form" :rules="Rules" label-suffix="：" label-width="120px" :inline="true" style="margin-left: 30px">
      <el-form-item label="工程师名称" prop="Name">
        <el-input style="width: 280px;" v-model="Form.Name"></el-input>
      </el-form-item>
      <el-form-item label="编号" prop="Code">
        <el-input style="width: 280px;" v-model="Form.Code"></el-input>
      </el-form-item>
      <el-form-item label="身份证" prop="IdCard">
        <el-input style="width: 280px;" v-model="Form.IdCard"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="Email">
        <el-input style="width: 280px;" v-model="Form.Email"></el-input>
      </el-form-item>
      <el-form-item label="QQ" prop="QQ">
        <el-input style="width: 280px;" v-model="Form.QQ"></el-input>
      </el-form-item>
      <el-form-item label="微信" prop="Weixin">
        <el-input style="width: 280px;" v-model="Form.Weixin"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="Mobile">
        <el-input style="width: 280px;" v-model="Form.Mobile"></el-input>
      </el-form-item>
      <el-form-item label="办事处" prop="Street">
        <spr-address
          :province-id.sync="Form.ProvinceId"
          :city-id.sync="Form.CityId"
          :county-id.sync="Form.CountyId"
          :address.sync="Form.Street"
        ></spr-address>
      </el-form-item>
    </el-form>
  </spr-dialog>
</template>

<script>
import SprDialog from './Dialog'
import SprAddress from '@/components/common/Address'
import _ from 'lodash'
export default {
  data() {
    return {
      Form: {
        Name: null,
        Code: null,
        IdCard: null,
        Email: null,
        Mobile: null,
        QQ: null,
        Weixin: null,
        ProvinceId: null,
        CityId: null,
        CountyId: null,
        Street: null,
      },
      Rules: {
        Name: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        Code: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        IdCard: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        Phone: [
          { required: true, message: '该字段必填', trigger: 'blur' },
          {pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/, message: '手机号格式错误'},
        ],
        Street: [{ required: true, message: '该字段必填', trigger: 'blur' }],
        Email: [{type: 'email', message: '邮箱格式错误'}],
      },
    }
  },
  props: {
    form: null,
    show: Boolean,
    title: String,
  },
  methods: {
    handleConfirm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('confirm', _.pick(this.Form, [
            'Id',
            'Name',
            'Code',
            'IdCard',
            'Email',
            'QQ',
            'Weixin',
            'Mobile',
            'ProvinceId',
            'CityId',
            'CountyId',
            'Street',
          ]))
        }
      })
    },
    handleOpen() {
      if (this.form.Id) {
        Object.assign(this.Form, this.form)
      } else {
        this.$set(this, 'Form', {
          Name: null,
          Code: null,
          IdCard: null,
          Email: null,
          Mobile: null,
          QQ: null,
          Weixin: null,
          ProvinceId: null,
          CityId: null,
          CountyId: null,
          Street: null,
        })
      }
    },
  },
  components: {
    SprDialog,
    SprAddress,
  },
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// EngineerDialog.vue?24c5d3ad